import React, { useEffect } from "react";
import { Link } from "gatsby";

// Import all product mobile video
import TKV03 from "../assets/video/tablet/tablet_sek2_KV03.mp4";
import TKV04 from "../assets/video/tablet/tablet_sek2_KV04.mp4";
import TKV06 from "../assets/video/tablet/tablet_sek2_KV06.mp4";
import TKV07 from "../assets/video/tablet/tablet_sek2_KV07.mp4";
import TKV10 from "../assets/video/tablet/tablet_sek2_KV10.mp4";
import TKV13 from "../assets/video/tablet/tablet_sek2_KV13.mp4";
import TKV17 from "../assets/video/tablet/tablet_sek2_KV17.mp4";
import MenuItemsList from "./MenuItemsList";

const SelectedProducts = ({ containerStyles = "", title, end, slug }) => {
  useEffect(() => {
    loadSelectedVideos();

    const selectedProducts = document.querySelectorAll(".selected-product");

    if (selectedProducts.length > 3) {
      for (let i = 3; i < selectedProducts.length; i++) {
        selectedProducts[i].remove();
      }
    }
  });

  function loadSelectedVideos() {
    const selectedVideos = document.querySelectorAll(".selected-video");

    const selectedImportsObject = {
      TKV03: TKV03,
      TKV04: TKV04,
      TKV06: TKV06,
      TKV07: TKV07,
      TKV10: TKV10,
      TKV13: TKV13,
      TKV17: TKV17,
    };

    selectedVideos.forEach((selectedVideo) => {
      for (const [key, value] of Object.entries(selectedImportsObject)) {
        if (key === selectedVideo.dataset.videoid) {
          selectedVideo.setAttribute("src", value);
        }
      }
    });
  }

  return (
    <div
      className={` ${containerStyles} lg:pb-[140px] md:py-[90px] container bg-gray-100 pt-[55px] pb-[40px]`}
    >
      <h2
        className="md:text-5xl text-3xl text-center"
        data-aos="fade-up"
        data-aos-duration="500"
        data-aos-easing="ease-in-out"
      >
        {title}
      </h2>
      <div className="lg:grid-cols-3 lg:mt-[65px] md:mt-[55px] md:gap-[16px] md:grid-cols-2 grid grid-cols-1 auto-rows-fr gap-[24px] mt-[40px]">
        {MenuItemsList.filter((menuItem) => menuItem.title === "Products").map(
          (menuItem) => {
            const renderSubmenu = menuItem.submenu.map((submenu, index) => {
              return (
                <React.Fragment key={index}>
                  {submenu.submenu
                    .filter((product) => product.selected === true)
                    .filter((product) => product.url !== slug)
                    .map((product, index) => {
                      return (
                        <Link
                          key={index}
                          to={product.url}
                          className="selected-product lg:last:flex md:last:hidden text-base no-underline text-center bg-white flex flex-col group"
                          data-aos="fade-up"
                          data-aos-duration="500"
                          data-aos-easing="ease-in-out"
                          data-aos-delay={index * 100}
                        >
                          <video
                            loop
                            playsInline
                            autoPlay
                            muted
                            disableRemotePlayback
                            className="lg:h-auto md:h-[207px] selected-video h-[225px] object-cover relative -z-0"
                            data-videoid={product.videoT}
                          >
                            <source type="video/webm" />
                          </video>
                          <div className="lg:pb-[60px] md:pb-[32px] px-[25px] pb-[40px] pt-[32px] flex flex-col h-full">
                            <h3 className="md:mb-[24px] text-2xl text-black-100 mb-[30px] group-hover:text-orange cursor-pointer">
                              {product.title}
                            </h3>

                            <div className="h-full flex flex-col justify-between">
                              <p className="mb-[25px] text-lg">
                                {product.description}
                              </p>
                              <p className="text-orange text-lg">{end}</p>
                            </div>
                          </div>
                        </Link>
                      );
                    })}
                </React.Fragment>
              );
            });
            return renderSubmenu;
          }
        )}
      </div>
    </div>
  );
};

export default SelectedProducts;
